module.exports = __webpack_public_path__ + "static/media/dashboardLight.60ab2f23.png";